<style lang="scss" src='./MenuLateral.scss' scoped></style>
<template src="./MenuLateral.html"></template>

<script>
  import {
    mapState,
    mapGetters,
    mapMutations
  } from "vuex";
  
  export default {
    name: 'MenuLateral',
    components: { },
    data() {
      return {};
    },
    computed: {
      ...mapState(['user', 'showMenu']),
      ...mapGetters("Main", ['getCurrentStore']),
      ...mapState("Main", ['categorysList']),
    },
    watch: {
      '$route': {
        handler: function () {
          this.setMenuVisibility(false)
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      ...mapMutations(["setMenuVisibility", 'setZipCodeModal','reset', "setCouponsModal"]),
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
  };
</script>